<a
  id="mainLogo"
  class="main-logo fixed-top p-2 mx-auto mt-2"
  routerLink="/"
  aria-label="Phoenix home"
>
  <img src="assets/images/logo-text.svg" alt="Phoenix logo" />
</a>
